import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ExamRoutineModel } from 'data/exam/examRoutine.model';

type SliceState = {
  status: 'idle' | 'loading' | 'data' | 'error';
  data: ExamRoutineModel[];
  error: any;
};

const initState: SliceState = {
  status: 'idle',
  data: [],
  error: false,
};

const setLoading = (): SliceState => ({ ...initState, status: 'loading' });

const setData: CaseReducer<SliceState, PayloadAction<ExamRoutineModel[]>> = (_, action) => ({
  error: false,
  data: action.payload,
  status: 'data',
});

const setError: CaseReducer<SliceState, PayloadAction<any>> = (state, action) => ({
  error: action.payload,
  data: [],
  status: 'error',
});

const examRoutineSlice = createSlice({
  name: 'examRoutine',
  initialState: initState,
  reducers: {
    setLoading,
    setData,
    setError,
  },
});

export default examRoutineSlice;
